import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col, Modal, Alert } from 'react-bootstrap';
import { store } from 'store/';
import DropZone from '../../components/DropZone';

export default class UploadCsvModal extends Component {
  constructor(props) {
    super(props);
    this.state = { uploadError: null };
  }

  render() {
    const { show, onClose, showUploadAlert } = this.props;
    const { token } = store.getState().auth;
    const { uploadError } = this.state;

    return (
      <Modal show={show} onHide={onClose} className="modal-90w" centered keyboard={false}>
        <Modal.Header
          closeButton
          style={{
            padding: '25px 25px 10px 25px',
          }}
        >
          <h3 className="modal-header-title-30mrg">Upload CSV</h3>
        </Modal.Header>
        <Modal.Body>
          {uploadError && (
            <Alert
              variant="danger"
              onClose={() => this.setState({ uploadError: null })}
              dismissible
            >
              {uploadError}
            </Alert>
          )}
          <Row className="g-2 p-4">
            <Col md>
              <Form.Group className="mb-2" controlId="title">
                <Form.Label as="h4">CSV*</Form.Label>
                <DropZone
                  folder="csv"
                  token={token}
                  handleSuccess={() => {
                    this.setState({ uploadError: null });
                    onClose(false);
                    showUploadAlert();
                  }}
                  handleError={msg => this.setState({ uploadError: msg })}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* <Row className="justify-content-md-center">
            <Button variant="link mb-5 mt-5" size="lg" type="button" onClick={this.handleDownload}>
              Download Sample CSV
            </Button>
          </Row> */}
        </Modal.Body>
      </Modal>
    );
  }
}

UploadCsvModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  showUploadAlert: PropTypes.func,
};

UploadCsvModal.defaultProps = {
  show: false,
  onClose: null,
  showUploadAlert: null,
};
